import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsGetAll, wsFindBy } from 'services/WService.js';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;

  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);

  const [zones, setZones] = useState([]);
  async function listZones() {
    let response = await wsFindBy('base/zone');
    if (response.success) {
      // Filtra las zonas que tengan code "NZ.IC" o "CH"
      const filteredZones = response.data.filter(zone => ['NZ','IC','CH'].includes(zone.code));
      setZones(filteredZones);
    }
  }

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }
  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (bPartnerSelect?.CodigoCategoria) {
      setDataChanging((prev) => ({
        ...prev,
        CodigoCategoria: bPartnerSelect?.CodigoCategoria || '',
      }));
    }
  }, [bPartnerSelect]);

  useEffect(() => {
    if (customerPortfolioB.open) {
      if (!customerPortfolioB.id) {listZones();};
      setDataChanging(customerPortfolioB);
    }
  }, [customerPortfolioB.open]);
  console.log(dataChanging);
  return (
    <>
      <Modal
        title={`Nueva Cuota de ventas para unilever`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity='sale/cuota-ventas'
         dataForce={
            {
              base_zone_id: dataChanging.base_zone_id
            }
        }
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <TextField
          label="Descripción"
          fullWidth
          type="text"
          name="description"
          margin="normal"
          value={dataChanging.description || ''}
          onChange={(e) => handleChange('description', e.target.value)}
          required
        />
        <Autocomplete
          disableClearable
          options={zones}
          getOptionLabel={(item) => `${item.description}`}
          renderInput={(params) => (
            <TextField {...params} label="Zonas" margin="normal" fullWidth />
          )}
          onChange={(e, item) => {handleChange('base_zone_id', item?.id);}}
          value={zones.find((zone) => zone.id === dataChanging.base_zone_id) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <TextField
          label="Cuota"
          fullWidth
          type="number"
          name="cuota"
          margin="normal"
          value={dataChanging.cuota || ''}
          onChange={(e) => handleChange('cuota', e.target.value)}
          required
        />
      </Modal>
    </>
  );
});

